//#region src/canvas.ts
const CanvasLib = new class {
	/**
	* Get pixel cooldown
	*
	* @param config
	* @returns Seconds to take to give the pixel
	*/
	getPixelCooldown(config) {
		return config.canvas.pixel.cooldown;
	}
}();
//#endregion
export { CanvasLib };

//# sourceMappingURL=canvas.mjs.map